module.exports = __webpack_public_path__ + "media/images/emblems/Kappelen-coat_of_arms-b51497fc2c939733c3f89b1d24898e16.svg";